export default __webpack_public_path__ + "01745124440421a04acfaaf1f81143d4.gif";